import React, { useEffect, useState } from "react";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Collapse from "@material-ui/core/Collapse";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import { useStyles } from "../../assets/jss/Layout";
import CustomTypography from "../CustomComponents/CustomTypography/CustomTypography";
import { getUserData } from "../../services/LocalStorageService";

const MenuItem = ({ group, selectedGroup, setSelectedGroup }) => {
    const classes = useStyles();
    function handleGroupClick(group) {
        setSelectedGroup(group);
    }
    return (
        <ListItem button className={selectedGroup && group.id === selectedGroup.id ? classes.selectedListItem : null} onClick={(event) => handleGroupClick(group)}>
            <ListItemText className={classes.groupNameItem}>
                {group.name}
            </ListItemText>
        </ListItem>
    );
};

const ExpandableMenuItem = ({ group, selectedGroup, setSelectedGroup, isExpanded, baseId }) => {
    const [open, setOpen] = useState(isExpanded);
    const classes = useStyles();
    function handleGroupClick(group) {
        setSelectedGroup(group);
    }
    function handleSubMenuClick() {
        setOpen(!open);
    }

    return (
        <div>
            <ListItem button className={selectedGroup && group.id === selectedGroup.id ? classes.selectedListItem : null}>
                <ListItemText className={classes.groupNameItem}
                    onClick={(event) => handleGroupClick(group)}>
                    {group.name}
                </ListItemText>
                {group.childCount ? (
                    <ListItemText className={classes.childCountBackground} onClick={(event) => handleSubMenuClick()}>
                        <CustomTypography
                            component="h1"
                            variant="h5"
                            className={classes.childCount}
                        >
                            {group.childCount ? group.childCount : null}
                        </CustomTypography>
                    </ListItemText>
                ) : null}
                {open ? <ExpandLess onClick={(event) => handleSubMenuClick()} /> : <ExpandMore onClick={(event) => handleSubMenuClick()} />}
            </ListItem>
            <Collapse in={open} timeout="auto" unmountOnExit style={open ? {
                borderLeft: "1px solid rgba(224, 227, 232)",
                marginLeft: "16px",
            } : {}}>
                <CreatMenu groupObj={group.childGroups} selectedGroup={selectedGroup} setSelectedGroup={setSelectedGroup} baseId={baseId} />
            </Collapse>
        </div>
    );
};

const CreatMenu = ({ groupObj, selectedGroup, setSelectedGroup, baseId }) => {
    const classes = useStyles();
    const [userData] = React.useState(getUserData);
    const createList = (groupObj) => {
        let menu = [];
        groupObj.map((group) => {
            if (Array.isArray(group.childGroups) && group.childGroups.length > 0) {
                menu.push(<ExpandableMenuItem
                    setSelectedGroup={setSelectedGroup}
                    selectedGroup={selectedGroup}
                    group={group}
                    key={group.id}
                    baseId={baseId}
                    isExpanded={(group.groupLevelId === '1' || group.id === (selectedGroup ? selectedGroup.id : 0) || group.id === userData.userGroupId || group.id === baseId)}
                />);
            } else {
                if (group.groupLevelId === "1") {
                    menu.unshift(<MenuItem
                        setSelectedGroup={setSelectedGroup}
                        selectedGroup={selectedGroup}
                        group={group}
                        key={group.id}
                    />);
                } else {
                    menu.push(<MenuItem
                        setSelectedGroup={setSelectedGroup}
                        selectedGroup={selectedGroup}
                        group={group}
                        key={group.id}
                    />);
                }
            }
        });
        return menu.concat();
    };

    return <List key={groupObj.id} className={classes.groupList}>{createList(groupObj)}</List>;
}

export default function Menu(props) {
    const [selectedGroup, setSelectedGroup] = useState(null);
    const [baseId, setBaseId] = useState("1");
    useEffect(() => {
        if (selectedGroup) {
            props.setSelectedCompany(selectedGroup);
        }
    }, [selectedGroup]);
    useEffect(() => {
        if (props.groupObj && props.groupObj.length > 0) {
            setBaseId(props.groupObj[0]);
        }
    }, [props.groupObj])
    return <CreatMenu groupObj={props.groupObj} selectedGroup={props.selectedGroup} setSelectedGroup={setSelectedGroup} baseId={baseId} />
}